/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DriverNotificationsSummaryDtoBase
 * auto generated base class for the model DriverNotificationsSummaryDtoModel.
 */
export const DriverNotificationsSummaryDtoModelBase = ModelBase
  .named('DriverNotificationsSummaryDto')
  .props({
    __typename: types.optional(types.literal("DriverNotificationsSummaryDto"), "DriverNotificationsSummaryDto"),
    reachableDrivers: types.union(types.undefined, types.number),
    unreachableDrivers: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DriverNotificationsSummaryDtoModelSelector extends QueryBuilder {
  get reachableDrivers() { return this.__attr(`reachableDrivers`) }
  get unreachableDrivers() { return this.__attr(`unreachableDrivers`) }
}
export function selectFromDriverNotificationsSummaryDto() {
  return new DriverNotificationsSummaryDtoModelSelector()
}

export const driverNotificationsSummaryDtoModelPrimitives = selectFromDriverNotificationsSummaryDto().reachableDrivers.unreachableDrivers
